/* eslint-disable */
import GrapesJS from 'grapesjs';
import 'grapesjs/dist/css/grapes.min.css';
// import mjml from 'grapesjs-mjml';
// import newsletter from 'grapesjs-preset-newsletter';
import webpage from 'grapesjs-preset-webpage';
import React from 'react';

import '../css/styles.scss';
import PropTypes from 'prop-types';
import { useStoreState } from 'easy-peasy';

const presets = {
	webpage,
	// newsletter,
	// mjml,
};

const Editor = React.forwardRef((props, ref) => {
	const {
		id,
		cssList,
		commands = [],
		onInit,
		onDestroy,
		presetType,
		blockManager,
		storageManager,
		styleManager,
		assetManager,
		width,
		height,
		components,
		blocks,
		children,
		devices,
	} = props;
	const template = useStoreState((state) => state.template.template);
	const [editor, setEditor] = React.useState(
		GrapesJS.editors.find((e) => {
			return e.getContainer().id === id;
		}),
	);
	const handleCleanup = React.useCallback(() => {
		if (editor) {
			if (onDestroy) {
				onDestroy(editor);
			}
			GrapesJS.editors = GrapesJS.editors.filter((e) => e !== editor);
			editor.destroy();
			if (document) {
				const container = document.getElementById(id);
				if (container) {
					container.innerHTML = '';
				}
			}
		}
	}, [editor, id, onDestroy]);

	const plugins = [presets[presetType], ...props.plugins];
	const pluginsOpts = {
		...props.pluginsOpts,
	};

	React.useEffect(() => {
		if (!editor) {
			const newEditor = GrapesJS.init({
				container: `#${id}`,
				// fromElement: true,
				canvas: {
					styles: cssList,
					attributes: {
						sandbox: 'allow-same-origin allow-scripts allow-popups allow-forms',
					},
				},
				commands: {
					defaults: [...commands],
				},
				allowScripts: 1,
				forceClass: false,
				blockManager,
				styleManager,
				storageManager,
				assetManager,
				// width: '100vw',
				height,
				plugins,
				pluginsOpts,
				traitManager: {
					appendTo: '.gjs-sm-sectors',
				},
				deviceManager: {
					devices,
				},
				cssIcons:
					'https://static.goalsmapper.com/public/personal_website/font-awesome.min.css',
			});
			// console.log('TCL: newEditor', newEditor);
			setEditor(newEditor);
			// console.log('TCL: editor', editor);

			// Set sandbox attribute on canvas iframe
			setTimeout(() => {
				const canvasIframe = newEditor.Canvas.getFrameEl();
				if (canvasIframe) {
					canvasIframe.setAttribute(
						'sandbox',
						'allow-same-origin allow-scripts allow-popups allow-forms allow-top-navigation-by-user',
					);
					console.log('Canvas iframe sandbox set:', canvasIframe.getAttribute('sandbox'));
				}
			}, 100);

			if (onInit) {
				onInit(newEditor);
			}
		}
		return handleCleanup;
	}, [
		editor,
		id,
		blockManager,
		styleManager,
		storageManager,
		onInit,
		presetType,
		onDestroy,
		width,
		height,
		blocks,
		components,
		handleCleanup,
		plugins,
		pluginsOpts,
		devices,
	]);
	if (editor) {
		console.log('selected:', editor.getSelected());
	}
	return (
		<div id={id} ref={ref} className={`drawer-opened ${template}`}>
			{children}
		</div>
	);
});

Editor.defaultProps = {
	id: 'grapesjs-react-editor',
	presetType: 'newsletter',
	plugins: [],
	blocks: [],
	blockManager: {},
	storageManager: {},
	styleManager: {},
	assetManager: {},
	width: 'auto',
	height: '100vh',
	components: [],
	devices: [
		{
			name: 'Desktop',
			width: '',
		},
		{
			name: 'Tablet',
			width: '768',
			widthMedia: '768',
		},
		{
			name: 'Mobile portrait',
			width: '480',
			widthMedia: '480',
		},
	],
};

Editor.propTypes = {
	id: PropTypes.string,
	onInit: PropTypes.func,
	onDestroy: PropTypes.func,
	devices: PropTypes.arrayOf(
		PropTypes.shape({
			width: PropTypes.string,
			height: PropTypes.string,
		}),
	),
	cssList: PropTypes.array,
};

export default Editor;
